module.exports = __webpack_public_path__ + "img/20200514_153047.7fcc35d4.jpg";